import { Link, Stack, Typography, styled, useTheme } from '@mui/material'
import { useObservableEagerState } from 'observable-hooks'
import { useCallback } from 'react'

import { useResponsive } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../systems/configurator-interface.js'

const TopLine = styled(Typography)(({ theme }) => ({
  paddingInlineEnd: theme.spacing(2),
}))

const BottomLine = styled(Typography)(({ theme }) => ({
  position: 'relative',
  paddingInlineStart: theme.spacing(1),
  transform: `translateX(-${theme.spacing(1)})`,

  '&::before': {
    content: '""',
    width: '1px',
    height: '100%',
    background: theme.palette.text.secondary,
    position: 'absolute',
    top: 0,
    left: 0,
  },
}))

const Container = styled(Stack)(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  backgroundColor: theme.palette.background.paper,
}))

const FooterLink = styled(Link)({
  cursor: 'pointer',
  whiteSpace: 'nowrap',
})

const AdminLink = () => {
  const theme = useTheme()
  const handleClick = useCallback(() => {
    window.location.href = '/admin.html'
  }, [])

  return (
    <FooterLink title="Admin" target="_blank" onClick={handleClick}>
      <Typography variant="caption" color={theme.palette.text.secondary}>
        Admin
      </Typography>
    </FooterLink>
  )
}

// Copied form Davcor RiteRails configurator
export const LegalFooter = () => {
  const theme = useTheme()
  const { isPhone } = useResponsive()
  const sessionService = configuratorInterface.useSessionService()
  const session = useObservableEagerState(sessionService.session$)

  // TODO: is analytics service available yet?
  const handlePrivacyPolicyClick = useCallback(() => {
    // TODO: Add analytics
    // analyticsService.push(DavcorAnalytics.PrivacyPolicyOpened())
  }, [])

  const handleTermsAndConditionsClick = useCallback(() => {
    // TODO: Add analytics
    // analyticsService.push(DavcorAnalytics.TermsAndConditionsOpened())
  }, [])

  const handleLogout = useCallback(() => {
    sessionService.clearSession()
  }, [sessionService])

  return (
    <Container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ height: 35, marginTop: 'auto' }}
    >
      <Stack direction="row" flexWrap="wrap" overflow="hidden">
        <TopLine variant="caption" color={theme.palette.text.secondary}>
          Davcor Group Pty Ltd
        </TopLine>
        <BottomLine variant="caption" color={theme.palette.text.secondary}>
          ABN 95 003 562 598
        </BottomLine>
      </Stack>
      <Stack direction="row" gap={3} alignItems="center" sx={{ flexWrap: isPhone ? 'wrap' : 'nowrap' }}>
        <FooterLink
          href="https://davcor.com.au/privacy-policy/"
          title="Privacy Policy"
          target="_blank"
          onClick={handlePrivacyPolicyClick}
        >
          <Typography variant="caption" color={theme.palette.text.secondary}>
            Privacy Policy
          </Typography>
        </FooterLink>
        <FooterLink
          href="https://davcor.com.au/terms-and-conditions/"
          title="Terms & Conditions"
          target="_blank"
          onClick={handleTermsAndConditionsClick}
        >
          <Typography variant="caption" color={theme.palette.text.secondary}>
            Terms & Conditions
          </Typography>
        </FooterLink>

        {(session.sessionPayload?.role === 'admin' || session.sessionPayload?.role === 'superadmin') && <AdminLink />}

        {phoenix.runtimeConfig.SHOW_USER_LOGOUT_BUTTON && (
          <FooterLink title="Logout" onClick={handleLogout}>
            <Typography variant="caption" color={theme.palette.text.secondary}>
              Logout
            </Typography>
          </FooterLink>
        )}
      </Stack>
    </Container>
  )
}
